import { render, staticRenderFns } from "./InteriorSliderTwo.vue?vue&type=template&id=234273d8&scoped=true&"
import script from "./InteriorSliderTwo.vue?vue&type=script&lang=js&"
export * from "./InteriorSliderTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234273d8",
  null
  
)

export default component.exports